import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { checkIsNewPartner } from 'legacy/lut/helpers/partners/checkIsNewPartner'
import { fetchNewPartnerById } from 'legacy/lut/services/partner/fetchNewPartnerById'

import { IContact } from 'clickNgo/entities/contact'
import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types/ICrudHelpers'
import { CrudStore } from 'core/types/crudStore'

import { fetchPartnerById } from '../partner/fetchPartnerById'

import { mapContactFromContactAllData } from './mapping/mapContactFromContactAllData'

interface IFetchContactsWithSameRole {
  role: string
  contactId: string
  partnerId: string
}

export const fetchContactsWithSameRole_old = async ({
  role,
  contactId,
  partnerId,
}: IFetchContactsWithSameRole) => {
  const isNewPartner = checkIsNewPartner(partnerId)
  const fetchPartnerFn = isNewPartner ? fetchNewPartnerById : fetchPartnerById
  const partner = await fetchPartnerFn(partnerId, {
    cacheKey: partnerId,
  })

  if (!partner) {
    return []
  }

  const isSubsidiaryOrAffiliate =
    partner.hierarchyType === PartnerHierarchyType.AFFILIATE ||
    partner.hierarchyType === PartnerHierarchyType.SUBSIDIARY
  const crud = CrudStore.get(CrudStoreItem.ContactAllData, contactId)

  const filterByRole: IDataProviderFilter = {
    logic: Logic.OR,
    filters: [
      {
        field: 'PR_HP_ROLE',
        operator: Operator.CONTAINS,
        value: role,
      },
      {
        field: 'PR_HP_ROLEExt',
        operator: Operator.CONTAINS,
        value: role,
      },
    ],
  }

  const defaultFilters: Array<IFilter | IDataProviderFilter> = [
    {
      field: 'TopPartnerID',
      operator: Operator.EQUAL,
      value: partner?.topPartnerId,
    },
    {
      logic: Logic.OR,
      filters: [
        {
          field: 'HierarchyType',
          operator: Operator.EQUAL,
          value: 'Headquarters',
        },
        {
          field: 'HierarchyType',
          operator: Operator.EQUAL,
          value: 'Branch',
        },
      ],
    },
    {
      field: 'ContactID',
      operator: Operator.NOTEQUAL,
      value: contactId,
    },
    filterByRole,
  ]

  const subsidiaryOrAffiliateFilters: Array<IFilter | IDataProviderFilter> = [
    {
      field: 'PartnerID',
      operator: Operator.EQUAL,
      value: partnerId,
    },
    {
      field: 'ContactID',
      operator: Operator.NOTEQUAL,
      value: contactId,
    },
    filterByRole,
  ]

  const filters: IDataProviderFilter = {
    logic: Logic.AND,
    filters: isSubsidiaryOrAffiliate ? subsidiaryOrAffiliateFilters : defaultFilters,
  }

  crud.setFilter(filters)
  crud.setPaging({
    page: 0,
    pageSize: 100,
  })

  return crud.fetch().then((result): IContact[] => {
    if (result && result.items) {
      return result.items.map(mapContactFromContactAllData).filter((contact) => {
        const { hpRoles } = contact
        return hpRoles.includes(role)
      })
    }

    return []
  })
}
